import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, CardMedia, CardContent, CardActions, Button, Typography, Paper } from '@mui/material'
import { ArrowForward } from '@mui/icons-material';
import { useProjects } from '../../hooks/useProjects';
import { OpalCard, paperStyles } from '../../components/OpalCard/OpalCard';

const FeaturedProjects = () => {
    const { projects } = useProjects();
    const navigate = useNavigate();

    return (
        <>
            <Typography gutterBottom={true} variant="h4" component="h3" noWrap>
                Featured projects
            </Typography>
            <Grid container spacing={3} sx={{ marginTop: '0.5rem' }}>
                {projects.map((project) => project.featured && (
                    <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={project._id}>
                        <OpalCard>
                            <Paper sx={{ ...paperStyles, padding: 0, overflow: 'hidden', maxWidth: 350 }}>
                                <CardMedia
                                    component="img"
                                    alt={project.images[0] && project.images[0].name}
                                    height="200"
                                    image={project.images[0] && project.images[0].path + '?width=350&height=300&crop=fill'}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" noWrap>
                                        {project.name}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        {project.projectType}
                                    </Typography>
                                    <Typography gutterBottom variant="overline" component="h2">
                                        {project.images ? 'Contains ' + project.images.length + ' Images' : 'No Images'}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small"
                                        endIcon={<ArrowForward />}
                                        onClick={() => navigate(`/project-edit?id=${project._id}`, { state: { mode: 'edit' } })}>
                                        Edit
                                    </Button>
                                </CardActions>
                            </Paper>
                        </OpalCard>
                    </Grid>
                ))}
            </Grid>
        </>
    )
}

export default FeaturedProjects;